import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import {
    loadComplianceLiaisonsFailure,
    loadComplianceLiaisonsFromCLEdit,
    loadComplianceLiaisonsSuccessfully
} from 'src/app/compliance/store/actions/compliance.actions';
import { KeyValue } from '../../../shared/models/key-value.model';
import { ComplianceClient } from '../../api/compliance-client.service';

@Injectable()
export class ComplianceLiaisonsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _complianceClient: ComplianceClient
    ) {}

    getComplianceLiaisons$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadComplianceLiaisonsFromCLEdit),
            exhaustMap(() => {
                return this._complianceClient.complianceLiaisons(false).pipe(
                    map((a) => a.map((x) => ({ key: x.id, id: x.id, name: x.name }) as KeyValue<number, string>)),
                    map((liaisons: KeyValue<number, string>[]) =>
                        loadComplianceLiaisonsSuccessfully({ complianceLiaisons: liaisons })
                    ),
                    catchError((error: unknown) => of(loadComplianceLiaisonsFailure({ error })))
                );
            })
        )
    );
}
